<template>
	<div class="text-center">
		<img draggable="false" class="img-fluid image" :src="url" />
	</div>
</template>

<script>
export default {
	name: "TimelineImage",
	props: {
		url: String,
	},
};
</script>

<style scoped>
	.image {
		max-height: 60vh;
	}
</style>